import { FileText, ClipboardCheck, Map } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * WD-T5: the card surfaces the job's REAL counts (server listProjects already
 * includes _count documents/jhas/constructionPlans) and its status — no
 * invented numbers, no hidden status.
 */
export function MyProjectCard({ project }: { project: any }) {
  const count = project._count ?? {};
  return (
    <Link to={`/my-jobs/${project.id}`} className="block bg-white rounded-xl shadow border border-gray-100 p-5 hover:shadow-lg hover:border-blue-300 transition">
      <div className="flex items-start justify-between gap-3">
        <h2 className="text-xl font-semibold text-gray-900">{project.name}</h2>
        {project.status ? (
          <span
            className={`shrink-0 rounded-full px-2.5 py-0.5 text-xs font-semibold ${
              project.status === 'ACTIVE'
                ? 'bg-green-100 text-green-800'
                : project.status === 'ON_HOLD'
                  ? 'bg-amber-100 text-amber-800'
                  : 'bg-gray-100 text-gray-700'
            }`}
          >
            {project.status}
          </span>
        ) : null}
      </div>
      <p className="text-sm text-gray-500 mt-1">{project.siteAddress}</p>
      <div className="flex flex-wrap gap-4 mt-5 text-sm text-gray-600">
        <span className="inline-flex items-center gap-1"><FileText className="h-4 w-4 text-blue-600" />{count.documents ?? 0} docs</span>
        <span className="inline-flex items-center gap-1"><ClipboardCheck className="h-4 w-4 text-green-600" />{count.jhas ?? 0} JHAs</span>
        <span className="inline-flex items-center gap-1"><Map className="h-4 w-4 text-orange-600" />{count.constructionPlans ?? 0} plans</span>
      </div>
    </Link>
  );
}
